import type { MarketMakerRequestStatusEnumType } from '@forgd/shared/enums'

const COMPARABLE_RFQ_STATUSES: MarketMakerRequestStatusEnumType[] = [
  'round_one_quotes_in_review',
  'round_two_quotes_in_review',
]

/**
 * Middleware to guard the compare quotes page.
 * Only allows access when the RFQ is in a reviewable state (quotes have been received).
 * Redirects to page-not-found for all other RFQ statuses.
 */
export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) {
    return
  }

  const rfqDetails = useRFQDetails()

  if (!rfqDetails.data) {
    await rfqDetails.fetch()
  }

  const canCompare = rfqDetails.data?.project.hasRFQ && COMPARABLE_RFQ_STATUSES.includes(rfqDetails.data?.rfq?.status as MarketMakerRequestStatusEnumType)

  if (!canCompare) {
    return navigateTo('/page-not-found')
  }
})
